<div class="card">
    <div class="card-body">
        <spk-search-grid [list]="'SearchTestSearchRow'" title="Searches" autoload="true" defaultSortProperty="Name ASC, AddDate DESC" showSearch="true" [leftLinks]="leftLinks"
            [rightLinks]="rightLinks" [headerLinks]="headerLinks" [filter]="filter" [csvExport]="false" [cardView]="true"></spk-search-grid>
    </div>
</div>